import React, {useState, useEffect} from 'react';
import {collection, query, where, limit, getDocs, updateDoc, doc} from 'firebase/firestore';
import Fuse from 'fuse.js';

const nameMap = [
    {"groupId": "1", "name": "Chad Barnes"},
    {"groupId": "1", "name": "Katy Barnes"},
    {"groupId": "1", "name": "Bode Barnes"},
    {"groupId": "1", "name": "Jake Barnes"},
    {"groupId": "1", "name": "Max Becker"},
    {"groupId": "2", "name": "Ben Barnes"},
    {"groupId": "2", "name": "Georgina Barnes"},
    {"groupId": "3", "name": "Aaron Becker"},
    {"groupId": "3", "name": "Keri Jacobs"},
    {"groupId": "4", "name": "Kayla Becker"},
    {"groupId": "5", "name": "Corey Becker"},
    {"groupId": "6", "name": "Mike Becker"},
    {"groupId": "6", "name": "Barb Becker"},
    {"groupId": "7", "name": "Jamie Shae"},
    {"groupId": "7", "name": "James Calhoun"},
    {"groupId": "8", "name": "Kayla Long"},
    {"groupId": "8", "name": "Garret Long"},
    {"groupId": "9", "name": "Mark Kraft"},
    {"groupId": "9", "name": "Tracey Kraft"},
    {"groupId": "9", "name": "Eli Kraft"},
    {"groupId": "9", "name": "Plus One"},
    {"groupId": "10", "name": "Ina Kraft"},
    {"groupId": "10", "name": "Madeline Kraft"},
    {"groupId": "11", "name": "Elizabeth Williams"},
    {"groupId": "12", "name": "Jim Williams"},
    {"groupId": "13", "name": "Jason Williams"},
    {"groupId": "14", "name": "Jayne Lewton"},
    {"groupId": "14", "name": "Scot Lewton"},
    {"groupId": "15", "name": "Jon Lewton"},
    {"groupId": "15", "name": "Jamie Lewton"},
    {"groupId": "16", "name": "Cody Lewton"},
    {"groupId": "16", "name": "Kirby Lewton"},
    {"groupId": "17", "name": "Abby Blacker"},
    {"groupId": "17", "name": "Ryan Blacker"},
    {"groupId": "18", "name": "John Sirianni"},
    {"groupId": "18", "name": "Ginger Sirianni"},
    {"groupId": "19", "name": "Deb Booth"},
    {"groupId": "19", "name": "Ben Booth"},
    {"groupId": "20", "name": "Mat Garwood"},
    {"groupId": "20", "name": "Stephanie Garwood"},
    {"groupId": "21", "name": "Corey Kleusner"},
    {"groupId": "21", "name": "Stacey Kleusner"},
    {"groupId": "22", "name": "Becky Lange"},
    {"groupId": "22", "name": "Kurt Lange"},
    {"groupId": "23", "name": "Don Schweitzer"},
    {"groupId": "23", "name": "Terri Schweitzer"},
    {"groupId": "24", "name": "Sydney Schweitzer"},
    {"groupId": "24", "name": "Evan Jurgensmeier"},
    {"groupId": "25", "name": "Gerry Schweitzer"},
    {"groupId": "25", "name": "Tina Schweitzer"},
    {"groupId": "26", "name": "Ryan Schweitzer"},
    {"groupId": "26", "name": "Caroline Schweitzer"},
    {"groupId": "27", "name": "Emily Fosse"},
    {"groupId": "27", "name": "Sam Fosse"},
    {"groupId": "28", "name": "Sara Schweitzer"},
    {"groupId": "28", "name": "Avery Tilley"},
    {"groupId": "29", "name": "Terri Gowin"},
    {"groupId": "29", "name": "Sandy Gowin"},
    {"groupId": "30", "name": "Laurie Fitch"},
    {"groupId": "30", "name": "Gerry Fitch"},
    {"groupId": "31", "name": "Carolyn Fitch"},
    {"groupId": "31", "name": "Cam Kaskocsak"},
    {"groupId": "32", "name": "Jim Schweitzer"},
    {"groupId": "32", "name": "Cindy Schweitzer"},
    {"groupId": "33", "name": "Ali Gowin"},
    {"groupId": "34", "name": "Austin Gowin"},
    {"groupId": "34", "name": "Shelby Gowin"},
    {"groupId": "35", "name": "Bob Schweitzer"},
    {"groupId": "36", "name": "Helen Schweitzer"},
    {"groupId": "37", "name": "Kim Johnson"},
    {"groupId": "37", "name": "JJ Johnson"},
    {"groupId": "38", "name": "Michael Berkley"},
    {"groupId": "38", "name": "Cassi Berkley"},
    {"groupId": "39", "name": "Jarod Harrison"},
    {"groupId": "39", "name": "Kai Harrison"},
    {"groupId": "40", "name": "Jesse Bates"},
    {"groupId": "41", "name": "Daniel Bates"},
    {"groupId": "41", "name": "Britney Bates"},
    {"groupId": "42", "name": "Lisa Ross"},
    {"groupId": "42", "name": "Bob Ross"},
    {"groupId": "43", "name": "Will Brandow"},
    {"groupId": "43", "name": "Gina Brandow"},
    {"groupId": "44", "name": "Seth Brandow"},
    {"groupId": "45", "name": "Rachel Brandow"},
    {"groupId": "45", "name": "Jordan Davis"},
    {"groupId": "46", "name": "Justin Berkley"},
    {"groupId": "46", "name": "Michelle Berkley"},
    {"groupId": "46", "name": "Greyson Berkley"},
    {"groupId": "46", "name": "Stella Berkley"},
    {"groupId": "47", "name": "Josh Berkley"},
    {"groupId": "47", "name": "Amanda Berkley"},
    {"groupId": "47", "name": "Jackson Berkley"},
    {"groupId": "47", "name": "Elery Berkley"},
    {"groupId": "47", "name": "Plus One"},
    {"groupId": "48", "name": "Rob Newton"},
    {"groupId": "49", "name": "Blake Richards"},
    {"groupId": "49", "name": "Tina Richards"},
    {"groupId": "49", "name": "Parker Richards"},
    {"groupId": "50", "name": "Mandi Burkett"},
    {"groupId": "50", "name": "Ryan Burkett"},
    {"groupId": "51", "name": "Miranda Bartusek"},
    {"groupId": "51", "name": "Nick Bartusek"},
    {"groupId": "52", "name": "Dick Quick"},
    {"groupId": "53", "name": "Amy Davis"},
    {"groupId": "53", "name": "Pat Davis"},
    {"groupId": "54", "name": "Dave Wiese"},
    {"groupId": "54", "name": "Leanne Wiese"},
    {"groupId": "54", "name": "Drew Wiese"},
    {"groupId": "54", "name": "Whitney Wiese"},
    {"groupId": "55", "name": "Melissa Miyamura"},
    {"groupId": "56", "name": "Shelly Wiersum"},
    {"groupId": "56", "name": "Tom Wiersum"},
    {"groupId": "57", "name": "Amy Gross"},
    {"groupId": "57", "name": "Jay Gross"},
    {"groupId": "58", "name": "Kristi Bentz"},
    {"groupId": "58", "name": "Travis Bentz"},
    {"groupId": "59", "name": "Rod Mestdagh"},
    {"groupId": "59", "name": "Teresa Mestdagh"},
    {"groupId": "60", "name": "Kevin Crawford"},
    {"groupId": "60", "name": "Jill Crawford"},
    {"groupId": "61", "name": "Lori Mestdagh"},
    {"groupId": "61", "name": "Scott Beaty"},
    {"groupId": "62", "name": "Beth Kershner"},
    {"groupId": "63", "name": "Sidd Somayajula"},
    {"groupId": "63", "name": "Savannah Stern"},
    {"groupId": "64", "name": "Saketh Undurty", "going": "false"},
    {"groupId": "64", "name": "Milauni Undurty", "going": "false"},
    {"groupId": "65", "name": "Phuong Tran"},
    {"groupId": "65", "name": "Jacob Li"},
    {"groupId": "66", "name": "Tanvi Yenna"},
    {"groupId": "67", "name": "Annie Howard"},
    {"groupId": "68", "name": "Andrew Novitskiy"},
    {"groupId": "68", "name": "Katy Novitskiy"},
    {"groupId": "69", "name": "Calvin Senteza"},
    {"groupId": "69", "name": "Gabby Anderson"},
    {"groupId": "70", "name": "Joe Evans"},
    {"groupId": "70", "name": "Vy Evans"},
    {"groupId": "71", "name": "Calvin Pelletier"},
    {"groupId": "72", "name": "Amanda Gibbons"},
    {"groupId": "73", "name": "Jesse Ledbetter"},
    {"groupId": "73", "name": "Betsy Pieper"},
    {"groupId": "74", "name": "Brian Garrels"},
    {"groupId": "75", "name": "Parker Reed"},
    {"groupId": "75", "name": "Paige Mall"},
    {"groupId": "76", "name": "Steve Maynard"},
    {"groupId": "76", "name": "Ellen Maynard"},
    {"groupId": "77", "name": "Cam Schneider"},
    {"groupId": "77", "name": "Sylvia Visser"},
    {"groupId": "78", "name": "Kaylea Cobb"},
    {"groupId": "78", "name": "CJ Buck"},
    {"groupId": "79", "name": "Mikey EnTin"},
    {"groupId": "79", "name": "Kayli Nartatez"},
    {"groupId": "80", "name": "Josh Petefish"},
    {"groupId": "81", "name": "Sara Wodka"},
    {"groupId": "82", "name": "Cassidy Mullins"},
    {"groupId": "83", "name": "Alana Hillgartner"},
    {"groupId": "83", "name": "Jules Henningsen"},
    {"groupId": "84", "name": "Samantha Gallo"},
    {"groupId": "85", "name": "Nick Fisher"},
    {"groupId": "85", "name": "Alyssa Leicht"},
    {"groupId": "86", "name": "Charlie Pattersen"},
    {"groupId": "86", "name": "Devin Pattersen"},
    {"groupId": "87", "name": "John Fisher"},
    {"groupId": "87", "name": "Sara Fisher"},
    {"groupId": "88", "name": "Ryan Garmoe"},
    {"groupId": "88", "name": "Plus One"},
    {"groupId": "89", "name": "Jake Bachman"},
    {"groupId": "90", "name": "Morgan Burmester"},
    {"groupId": "91", "name": "Greg Rudolph"},
    {"groupId": "91", "name": "Tristin Snodgrass"},
    {"groupId": "92", "name": "Emma Seibert"},
    {"groupId": "92", "name": "Chase Seibert"},
    {"groupId": "93", "name": "Becca Stephens"},
    {"groupId": "93", "name": "Aiden McDonald"},
    {"groupId": "94", "name": "Meredith Brown"},
    {"groupId": "94", "name": "Plus One"},
    {"groupId": "95", "name": "Maggie Goldhammer"},
    {"groupId": "95", "name": "Chase Goldhammer"},
    {"groupId": "96", "name": "Brendan Pendegraft"},
    {"groupId": "96", "name": "Alex Pendegraft"},
    {"groupId": "97", "name": "Sam Bates"},
    {"groupId": "97", "name": "Lily Noonan"},
    {"groupId": "98", "name": "Madi Delk"},
    {"groupId": "98", "name": "Plus One"},
    {"groupId": "99", "name": "Kathy Pingel"},
    {"groupId": "99", "name": "Ron Zeigler"},
    {"groupId": "100", "name": "Tommy Anderson"},
    {"groupId": "101", "name": "Connor Bredback"},
    {"groupId": "101", "name": "Plus One"},
    {"groupId": "102", "name": "Claire Guderjahn"},
    {"groupId": "103", "name": "Meredith Toebben"},
    {"groupId": "104", "name": "Christina Docter"},
    {"groupId": "104", "name": "Aaron Docter"},
    {"groupId": "105", "name": "Emily Bressler"},
    {"groupId": "106", "name": "Tyler Thompson"},
    {"groupId": "106", "name": "Hanna McClatchey"},
    {"groupId": "107", "name": "Addy Evans"},
    {"groupId": "108", "name": "Travis Reinders"},
    {"groupId": "109", "name": "Nikolina Petrovic"},
    {"groupId": "109", "name": "Michelle Petrovic"},
    {"groupId": "110", "name": "Chris Guttin"},
    {"groupId": "110", "name": "Sue Guttin"},
    {"groupId": "111", "name": "John Currier"},
    {"groupId": "111", "name": "Renee Currier"},
    {"groupId": "112", "name": "Gary Brazelton"},
    {"groupId": "112", "name": "Jen Brazelton"},
    {"groupId": "113", "name": "Dermot Hayes"},
    {"groupId": "113", "name": "Caroline Hayes"},
    {"groupId": "114", "name": "Steve Haun"},
    {"groupId": "114", "name": "Monica Haun"},
    {"groupId": "115", "name": "Beth Day"},
    {"groupId": "115", "name": "Kevin Day"},
    {"groupId": "116", "name": "Michael Nyamira"}
];

export function RsvpForm({database, searchInput}) {
    const [guests, setGuests] = useState([]);

    useEffect(() => {
        const guestListRef = collection(database, 'guest-list');
        
        (async() => {
            const fuse = new Fuse(nameMap, {
                keys: ['name'],
                threshold: .5
            });

            const result = fuse.search(searchInput);

            if (result.length) {
                const {groupId} = result[0].item;

                const groupQuery = query(
                    guestListRef,
                    where('groupId', '==', groupId)
                );

                console.log('Found user, querying for group...');

                const groupQueryResult = await getDocs(groupQuery);
                const guests = groupQueryResult.docs.map((guest) => {
                    return {
                        id: guest.id,
                        ...guest.data()
                    };
                });

                setGuests(guests);
            } else {
                console.log('No matching RSVP found.');
                setGuests(null);
            }
        })()
    }, [])

    async function rsvp(e, id, going) {
        const docRef = doc(database, 'guest-list', id);

        console.log('Updating RSVP...')

        await updateDoc(docRef, {going})

        const previouslySelected = document.getElementsByClassName(`${id} selected`);

        if (previouslySelected && previouslySelected[0]) {
            previouslySelected[0].classList.remove('selected');
        }

        e.target.classList.add('selected');
    }

    return (
        <div className='rsvp-form-wrapper'>
            <div className='rsvp-form'>
                {!guests && <span className='not-found'>Your RSVP was not found. Please try again.</span>}
                {guests && guests.map((guest) => {
                    return (
                        <div key={guest.id} className='rsvp-row'>
                            <span>{guest.name}</span>
                            <div className='button-wrapper'>
                                <button
                                    className={guest.going === 'true' ? `${guest.id} selected` : guest.id}
                                    onClick={(e) => rsvp(e, guest.id, 'true')}
                                >
                                    Going
                                </button>
                                <button 
                                    className={guest.going === 'false' ? `${guest.id} selected` : guest.id}
                                    onClick={(e) => rsvp(e, guest.id, 'false')}
                                >
                                    Can't Go
                                </button>
                            </div>
                        </div>
                    );
                })}
                {guests && guests.length > 0 && (
                    <React.Fragment>
                        <p>November 22, 2026</p>
                        <p>5:00pm - 9:00pm</p>
                        <p>Noah's Ark Ristorante<br/>2400 Ingersoll Ave<br/>Des Moines, IA</p>
                        <p>Dress Code: Cocktail Attire</p>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
}
